import { useRoute } from 'wouter'

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import { ToolsBillOfMaterials } from '@/state'
import { DocumentTemplate } from './DocumentTemplate'

export const MAX_PARTS_PER_PAGE = 12
export const ToolsBillOfMaterialsDocument = ({
  versionName,
  createdAt,
  isLatestDocumentVersion,
  parentRef,
  tools = [],
  index,
}: {
  versionName: string
  createdAt: string
  isLatestDocumentVersion?: boolean
  parentRef?: any
  tools: ToolsBillOfMaterials
  index: number
}) => {
  const [isPrintPage] = useRoute(/print$/)

  if (isPrintPage) {
    return (
      <DocumentTemplate
        id={`tools-bom--${index}`}
        title="Tools Bill of Materials"
        createdAt={createdAt}
        versionName={versionName}
        isLatestDocumentVersion={isLatestDocumentVersion}
        key={index}
        order={4 + index}
        parentRef={parentRef}
      >
        <div>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Tool name</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {tools.map((tool, i) => (
                <TableRow key={i}>
                  <TableCell className="py-1 px-2.5">{tool.toolName}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </DocumentTemplate>
    )
  }
  return (
    <div ref={parentRef}>
      <DocumentTemplate
        id={`tools-bom--${index}`}
        title="Tools Bill of Materials"
        createdAt={createdAt}
        versionName={versionName}
        isLatestDocumentVersion={isLatestDocumentVersion}
        key={index}
        order={4 + index}
        parentRef={parentRef}
      >
        <div>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Tool name</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {tools.map((tool, i) => (
                <TableRow key={i}>
                  <TableCell className="py-1 px-2.5">{tool.toolName}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </DocumentTemplate>
    </div>
  )
}
